import { render, staticRenderFns } from "./AuctionViewingInformationLink.vue?vue&type=template&id=19919872&scoped=true"
import script from "./AuctionViewingInformationLink.vue?vue&type=script&lang=js"
export * from "./AuctionViewingInformationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19919872",
  null
  
)

export default component.exports